import React from 'react';
import { useForm } from 'react-hook-form';

const RegeneratePostForm = ({ post, onRegenerateSubmit, showProductImage = false }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    defaultValues: {
      userInput: '',
    },
  });

  const onSubmit = async (data) => {
    if (!data.userInput.trim()) return;

    await onRegenerateSubmit(data.userInput);
    reset(); // Clear form after successful submission
  };

  const isRegenerating = post?.status === 'regeneration' || isSubmitting;

  return (
    <div className='h-full grid grid-rows-[auto_1fr] overflow-hidden'>
      <h3 className='text-lg font-semibold text-gray-900 mb-4'>Regenerate Post</h3>

      <form onSubmit={handleSubmit(onSubmit)} className='overflow-y-auto space-y-4'>
        <p className='text-sm text-gray-600'>
          Provide input to regenerate this post with new content.
        </p>

        {/* Show product image if post type is product and showProductImage is true */}
        {post?.type === 'product' && post.data?.imageUrl && showProductImage && (
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>Product Image:</label>
            <div className='w-full border-2 border-gray-300 rounded-lg overflow-hidden bg-gray-50'>
              <img
                src={post.data.imageUrl}
                alt='Product'
                className='w-full h-auto object-contain max-h-48'
              />
            </div>
            <p className='text-xs text-gray-500 mt-2 italic'>💡 Reference for regeneration</p>
          </div>
        )}

        <div className='flex flex-col flex-1'>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Your Instructions: <span className='text-red-500'>*</span>
          </label>
          <textarea
            {...register('userInput', {
              required: 'Please provide instructions',
              minLength: {
                value: 3,
                message: 'Instructions must be at least 3 characters',
              },
            })}
            placeholder='e.g., Make it more engaging...'
            disabled={isRegenerating}
            className='w-full px-4 py-3 text-sm border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none disabled:bg-gray-50 disabled:cursor-not-allowed'
            rows={5}
          />
          {errors.userInput && (
            <p className='text-red-500 text-xs mt-1'>{errors.userInput.message}</p>
          )}

          <button
            type='submit'
            disabled={isRegenerating}
            className={`w-full px-6 py-3 mt-4 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 ${
              isRegenerating
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            }`}
          >
            {isRegenerating ? (
              <>
                <div className='w-5 h-5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin'></div>
                <span>Regenerating...</span>
              </>
            ) : (
              <span>Regenerate Post</span>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default RegeneratePostForm;
